
/**
 * 에러 메시지 타입에 따라 에러 메시지 출력 (alert? html?)
 * @param {string} message
 * @param {object} msgType
 */
type MessgeObj = {
  message: string,
  msgType: {
    type: 'alert' | 'text' | 'console' | 'confirm' | 'ncui.modal',
    msgArea?: HTMLElement
  }
};

export const displayMesssage = ({message, msgType}: MessgeObj): boolean | void =>{
  message = message.replace(/\\n/g,'\n').replace(/\\r/g,'\r');

  const {type, msgArea} = msgType;

  switch (type){
    case 'alert' :
      alert(message);
    break;
    case 'text' :
      if (!msgArea) throw Error(`"msgArea"is not found. If Message type is "${type}", It need DOM Element to display message..`);
      msgArea.innerHTML = message.replace(/\r\n/g, '<br>').replace(/\n/g, '<br>').replace(/\r/g, '<br>');
    break;
    case 'console' :
      console.error(message);
    break;
    case 'confirm' :
      return confirm(message);
    break;
    case 'ncui.modal' :
      // [TODO] 구현
      if (window.ncui.modal.uiAlert) {
        new window.ncui.modal.uiAlert().open({
          title: message.replace(/\r\n/g, '<br>').replace(/\n/g, '<br>').replace(/\r/g, '<br>')
        });
      }else{
        alert(message);
      }
    break;

    // TODO : 토스트 메시지등...
  }
};

/**
 * ${userName} 님을 ${guildName} 에서 추방하시게습니까?
 * 같은 메시지를 치환시킨다.
 *
 * MessageSubstitutionObj({
 *   msg: ${userName} 님을 ${guildName} 에서 추방하시게습니까?,
 *   masgArgs: {
 *      userName: 'cress',
 *      guildName: 'cat_guild'
 *   }
 * })
 *
 */
type MessageSubstitutionObj = {
  msg: string,
  msgArgs: Record<string, string>
};

export const msgSubstitution = ({msg, msgArgs}: MessageSubstitutionObj): string => {
  const matches = [...msg.matchAll(/\${([\s]*[^;\s{]+[\s]*)\}/g)];
  console.log(matches);

  for (const {0: originString, 1: key} of matches) {
    if(!msgArgs[key]) {
      console.error(`Not a msgArg for ${key}`);
      continue;
    }

    msg = msg.replace(originString, msgArgs[key]);
  }

  return msg;
};




